<template>
    <div>
        <PageTitle :title="$t('eventos.packs_eventos')" class="stretch"/>
        <FirstBanner/>

        <div class="container mt-2">
            <SearchEvents
                :placeholder="$t('teatros.buscar_placeholder')"
                :teatro="configuracion.hash_teatro"
            />
        </div>

        <ContentOrLoading>
            <template v-if="packs">
                <ListadoPacks :packs="packs" v-if="packs.data.length > 0"/>
                <NoEvents v-else/>
            </template>
        </ContentOrLoading>        
    </div>
</template>
  
<script>
    import PageTitle from '@/components/frontend/shared/PageTitle'
    import FirstBanner from '@/components/frontend/shared/FirstBanner'
    import SearchEvents from '@/components/frontend/events/SearchEvents'
    import ContentOrLoading from '@/components/backend/components/ContentOrLoading';
    import NoEvents from '@/components/frontend/events/listado/NoEvents';
    import ListadoPacks from '../../../components/frontend/packs/ListadoPacks.vue';
    import { useHead } from '@/composables/common/seo/useHead';

    export default {
        data() {
            return {
                packs: null
            }
        },
        created() {
            useHead("Packs de eventos");
            this.getPacks();
        },
        methods: {
            getPacks() {
                const params = {                    
                    filters: {
                        tid : this.configuracion.hash_teatro
                    }
                }

                this.$store.dispatch(this.config.getVuexAlias("front.packs.index"), params).then(res => {
                    this.packs = res.data;
                });
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
        },
        components: {
            PageTitle, FirstBanner, SearchEvents, ContentOrLoading, NoEvents, ListadoPacks
        }
    };
</script>
  